/**
 * SpeechLine — one spoken line in the Activity View. Answers carry the Synthetic badge; alerts are
 * marked as needing the user; parts and files the line refers to are chips ("that chart").
 */

import { TriangleAlert, Volume2 } from 'lucide-react';
import SpecialistDot from './SpecialistDot.jsx';
import SyntheticBadge from './SyntheticBadge.jsx';
import { clockOf } from './agentUi.js';
import './AgentStream.css';

export default function SpeechLine({ speech, specialist = null, onOpenCitation, onOpenFile }) {
  if (!speech) return null;
  const cls = speech.class || 'narration';
  const parts = (speech.refs?.parts || []).filter(Boolean);
  const files = (speech.refs?.files || []).filter(Boolean);
  return (
    <div className={`astream__speech is-${cls}`}>
      <div className="astream__speech-head">
        <SpecialistDot specialist={specialist} showName size={7} />
        {cls === 'alert' && (
          <span className="astream__speech-tag is-decide">
            <TriangleAlert size={11} aria-hidden="true" /> For you
          </span>
        )}
        {cls === 'confirmation' && (
          <span className="astream__speech-tag">
            <Volume2 size={11} aria-hidden="true" /> Confirmed
          </span>
        )}
        {cls === 'readback' && <span className="astream__speech-tag">Read-back</span>}
        <span className="astream__speech-time">{clockOf(speech.at)}</span>
      </div>
      <p className="astream__speech-text">{speech.text}</p>
      {(parts.length > 0 || files.length > 0 || cls === 'answer') && (
        <div className="astream__speech-foot">
          {parts.map((p) => (
            <button key={p} type="button" className="astream__cite" onClick={() => onOpenCitation?.({ cad_id: p })} title="Open the part dossier">
              {p}
            </button>
          ))}
          {files.map((f) => (
            <button key={f} type="button" className="astream__cite is-file" onClick={() => onOpenFile?.(f)} title="Open in the Workbench">
              {f.split('/').pop()}
            </button>
          ))}
          {cls === 'answer' && <SyntheticBadge />}
        </div>
      )}
    </div>
  );
}
